<template>
  <div class="device">
    <div class="container-fluid py-4">
      <h2 class="h4 fw-medium mb-4">{{ $t("__foraManagement") }}</h2>
      <div class="d-flex flex-wrap align-items-center justify-content-start justify-content-md-between">
        <div class="device-select me-2 mb-2">
          <select v-model="filterType" class="form-select rounded-pill me-2">
            <option :value="null">{{ $t("__all") }}</option>
            <option :value="1">
              {{ $t("__bound") + $t("__agency") }}
            </option>
            <option :value="0">
              {{ $t("__unbound") + $t("__agency") }}
            </option>
          </select>
        </div>
        <div class="device-select me-2 mb-2">
          <select v-model="filterDeviceType" class="form-select rounded-pill me-2">
            <option value="all">{{ $t("__all") }}</option>
            <option value="glucose">
              {{ $t("__chilineDeviceGlucose") }}
            </option>
            <option value="oxygen">
              {{ $t("__chilineDeviceOxygen") }}
            </option>
            <option value="temperature">
              {{ $t("__foraDeviceForeheadTemperature") }}
            </option>
              <option value="ear_temperature">
              {{ $t("__foraDeviceEarTemperature") }}
            </option>
            <option value="pressure">
              {{ $t("__chilineDevicePressure") }}
            </option>
            <option value="ketone">
              {{ $t("__chilineDeviceKetone") }}
            </option>
            <option value="uric_acid">
              {{ $t("__chilineDeviceUricAcid") }}
            </option>
            <option value="cholesterol">
              {{ $t("__chilineDeviceCholesterol") }}
            </option>
            <option value="respiratory_rate">
              {{ $t("__foraDeviceRespiratoryRate") }}
            </option>
            <option value="pain_index">
              {{ $t("__foraDevicePainIndex") }}
            </option>
            <option value="bowel_movement_count">
              {{ $t("__foraDeviceBowelMovementCount") }}
            </option>
          </select>
        </div>
        <div v-if="filterType !== 0" class="d-flex align-items-center me-2 mb-2">
          <div class="device-report-select">
            <select v-model="searchAgency" class="form-select rounded-pill me-2">
              <option :value="null">{{ $t("__all") + " ( " + $t('__agencyName') + ' / ' + $t('__codeName') + " )"}}</option>
              <option v-for="item in allAgencys" :value="item.id" :key="'agent'+ item.id">
                {{ item.name + ' / ' + item.codename }}
              </option>
            </select>
          </div>
        </div>
        <div class="me-2 mb-2">
          <form @submit.prevent="searchDevice">
            <div class="input-group rounded-pill">
              <input
                v-model="search"
                type="text"
                class="form-control rounded-pill"
                :placeholder="$t('__searchDeviceSerialId')"
                aria-label="search"
                aria-describedby="search"
              />
              <button
                type="submit"
                class="btn btn-link px-2 text-dark"
                id="search"
              >
                <i class="bi bi-search"></i>
              </button>
              <button
                v-if="search"
                type="button"
                class="btn btn-primary px-3 ms-1 rounded-pill"
                id="clearSearch"
                @click="clearSearch"
              >
                {{ $t("__clearSearch") }}
              </button>
            </div>
          </form>
        </div>
        <div class="me-2 me-auto mb-2">
          <form @submit.prevent="searchAgencyByName">
            <div class="input-group rounded-pill">
              <input
                v-model="searchAgencyKeyword"
                type="text"
                class="form-control rounded-pill"
                :placeholder="$t('__searchAgencyName')"
                aria-label="search"
                aria-describedby="search"
              />
              <button
                type="submit"
                class="btn btn-link px-2 text-dark"
                id="search"
              >
                <i class="bi bi-search"></i>
              </button>
              <button
                v-if="searchAgencyKeyword"
                type="button"
                class="btn btn-primary px-3 ms-1 rounded-pill"
                id="clearSearch"
                @click="clearSearch"
              >
                {{ $t("__clearSearch") }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- 批次操作工具列 -->
      <div class="d-flex align-items-center mb-3">
        <button
          v-show="!isShowSelected && hasPermission('fora.update')"
          @click="isShowSelected = true"
          class="me-2 fs-5 btn btn-primary px-2 rounded-circle lh-sm mb-2 mb-md-0"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="$t('__select')"
        >
          <i class="bi bi-check2-square"></i>
        </button>
        <button
          v-show="isShowSelected"
          @click="isShowSelected = false"
          class="me-2 fs-5 btn btn-link px-2 rounded-circle lh-sm mb-2 mb-md-0"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="$t('__closeSelect')"
        >
          <i class="bi bi-arrow-left"></i>
        </button>
        <button
          v-show="isShowSelected"
          @click="selectAllRows"
          class="me-2 fs-5 btn btn-primary px-2 rounded-circle lh-sm mb-2 mb-md-0"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="$t('__allSelect')"
        >
          <i class="bi bi-check-all"></i>
        </button>
        <button
          v-show="isShowSelected && selected.length"
          @click="showBatchEditModal"
          class="me-2 btn btn-primary px-2 rounded-circle lh-sm mb-2 mb-md-0"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="$t('__edit')"
        >
          <i class="bi bi-pencil"></i>
        </button>
        <button
          v-show="isShowSelected && selected.length"
          @click="clearSelected"
          class="me-2 fs-5 btn btn-outline-primary px-2 rounded-circle lh-sm mb-2 mb-md-0"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="$t('__clearAll')"
        >
          <i class="bi bi-x"></i>
        </button>
        <div>
          <button
            v-show="!isShowSelected && hasPermission('fora.create')"
            @click="showModal()"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="$t('__add')"
            class="me-2 fs-5 btn btn-primary px-2 rounded-circle lh-sm mb-2 mb-md-0"
          >
            <i class="bi bi-plus"></i>
          </button>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <b-table
            :responsive="$store.state.windowWidth > $store.state.breakpoints.sm"
            :stacked="$store.state.windowWidth <= $store.state.breakpoints.sm"
            striped
            borderless
            no-provider-filtering
            head-variant="light"
            selectable
            :items="filterItem"
            :fields="fields"
            :sort-desc="sortDesc"
            :sort-by="sortBy"
            select-mode="multi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            @row-selected="onRowSelected"
            ref="selectableTable"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>

            <template v-slot:cell(selected)="{ rowSelected }">
              <input
                :checked="rowSelected"
                class="form-check-input"
                type="checkbox"
                disabled
              />
            </template>

            <template v-slot:cell(type)="data">
              <span v-if="data.item.type === 'glucose'">
                {{ $t('__chilineDeviceGlucose') }}
              </span>
              <span v-else-if="data.item.type === 'oxygen'">
                {{ $t('__chilineDeviceOxygen') }}
              </span>
              <span v-else-if="data.item.type === 'temperature'">
                {{ $t('__foraDeviceForeheadTemperature') }}
              </span>
                <span v-else-if="data.item.type === 'ear_temperature'">
                {{ $t('__foraDeviceEarTemperature') }}
              </span>
              <span v-else-if="data.item.type === 'pressure'">
                {{ $t('__chilineDevicePressure') }}
              </span>
              <span v-else-if="data.item.type === 'ketone'">
                {{ $t('__chilineDeviceKetone') }}
              </span>
              <span v-else-if="data.item.type === 'uric_acid'">
                {{ $t('__chilineDeviceUricAcid') }}
              </span>
              <span v-else-if="data.item.type === 'cholesterol'">
                {{ $t('__chilineDeviceCholesterol') }}
              </span>
              <span v-else-if="data.item.type === 'respiratory_rate'">
                {{ $t('__foraDeviceRespiratoryRate') }}
              </span>
              <span v-else-if="data.item.type === 'pain_index'">
                {{ $t('__foraDevicePainIndex') }}
              </span>
              <span v-else-if="data.item.type === 'bowel_movement_count'">
                {{ $t('__foraDeviceBowelMovementCount') }}
              </span>
              <span v-else>
                {{ $t('__chilineDeviceNoType') }}
              </span>
            </template>

            <template v-slot:cell(agency)="data">
              {{
                data.item.agency && data.item.agency ?
                data.item.agency.name + " / " + data.item.agency.codename :
                ""
              }}
            </template>

            <template v-slot:cell(resident)="data">
              {{
                data.item.resident && data.item.resident ?
                  data.item.resident.name :
                  ""
              }}
            </template>

            <template v-slot:cell(started_at)="data">
              {{ data.item.started_at ? new Date(data.item.started_at).format('yyyy-MM-dd') : '' }}
            </template>

            <template v-slot:cell(ended_at)="data">
              {{ data.item.ended_at ? new Date(data.item.ended_at).format('yyyy-MM-dd') : '' }}
            </template>

            <template v-slot:cell(status)="data">
              <div class="status-switch">
                <input
                  type="checkbox"
                  :id="'fora-switch-' + data.item.id"
                  :checked="data.item.status"
                  @click.prevent="changeStatusAlert(data.item)"
                />
                <label :for="'fora-switch-' + data.item.id"></label>
              </div>
            </template>

            <template v-slot:cell(active)="data">
              <div class="d-flex">
                <button
                  v-if="hasPermission('fora.update')"
                  @click="showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1 text-dark"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="$t('__edit')"
                >
                  <i class="bi bi-pencil mx-1 fs-5"></i>
                </button>
                <button
                  v-if="hasPermission('fora.delete')"
                  @click="deleteDeviceAlert(data.item.id)"
                  type="button"
                  class="btn btn-link px-1 text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="$t('__delete')"
                >
                  <i class="bi bi-trash fs-5"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>

      <div class="row align-items-center mt-3" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          {{ $t('__paginationInfo', {
            startNub: currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1,
            entNub: currentPage == 1
              ? totalRows > perPage
                ? perPage
                : totalRows
              : perPage * (currentPage - 1) + perPage > totalRows
              ? totalRows
              : perPage * (currentPage - 1) + perPage ,
            sum: totalRows
            })
          }}
        </div>
        <div class="col-sm col-12">
          <select class="form-select rounded-pill me-2  mb-2" v-model="perPage">
            <option :value="10">
              {{ '顯示數量／頁：10' }}
            </option>
            <option :value="25">
              {{ '顯示數量／頁：25' }}
            </option>
            <option :value="50">
              {{ '顯示數量／頁：50' }}
            </option>
          </select>
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3"
          ></b-pagination>
        </div>
      </div>
    </div>

    <!-- 單筆編輯 / 新增 Modal -->
    <div class="modal fade cms-style" tabindex="-1" id="edit" ref="editModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="submitForm">
            <div class="modal-header">
              <h5 class="modal-title fw-medium">
                {{ isEdit ? $t("__editDevice") : $t("__addDevice") }}
              </h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="mb-3" v-if="isSystemManage">
                <label for="MDeviceId" class="form-label fw-medium required">{{
                  $t("__foraDeviceId")
                }}</label>
                <textarea
                  v-if="!isEdit"
                  v-model="modalData.MDeviceId"
                  class="form-control"
                  :class="{
                    'is-invalid': validate && validate.msg.MDeviceId
                  }"
                  id="MDeviceId"
                  rows="3"
                  :placeholder="$t('__foraDeviceId') + ' (' + $t('__separateByCommaOrNewline') + ')'"
                  required
                ></textarea>

                <input
                  v-if="isEdit"
                  v-model="modalData.MDeviceId"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': validate && validate.msg.MDeviceId
                  }"
                  id="MDeviceId"
                  required
                />

                <div class="invalid-feedback" v-if="validate && validate.msg.MDeviceId">
                  <div v-for="(msg, index) in validate.msg.MDeviceId" :key="index">
                    {{ msg }}
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="isSystemManage">
                <label for="GroupName" class="form-label fw-medium required">{{
                    $t("__foraGroupName")
                  }}</label>
                <input
                  v-model="modalData.group_name"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': validate && validate.msg.GroupName
                  }"
                  id="GroupName"
                  required
                />

                <div class="invalid-feedback" v-if="validate && validate.msg.GroupName">
                  <div v-for="(msg, index) in validate.msg.GroupName" :key="index">
                    {{ msg }}
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="isSystemManage">
                <label for="agency_id" class="form-label fw-medium">{{
                    $t("__agencyCodename") + " / " + $t("__agencyName")
                  }}</label>

                <v-select
                  v-if="allAgencys !== null"
                  v-model="modalData.agency_id"
                  @input="modalData.resident_id = null"
                  :options="allAgencys"
                  label="codename"
                  :reduce="agency => agency.id"
                  :placeholder="$t('__searchAgencyName')"
                  class="style-chooser"
                  :components="{Deselect, OpenIndicator}"
                  :get-option-label="option => `${option.codename} / ${option.name}`"
                  :class="{
                      'is-invalid': validate && validate.msg.agency_id
                    }"
                >
                </v-select>

                <div class="invalid-feedback" v-if="validate && validate.msg.agency_id">
                  <div v-for="(msg, index) in validate.msg.agency_id" :key="index">
                    {{ msg }}
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="isSystemManage">
                <label for="resident_id" class="form-label fw-medium">{{
                    $t("__foraResident")
                  }}</label>

                <select
                  v-model="modalData.resident_id"
                  class="form-select"
                  id="editModal_resident_id"
                  :class="{'is-invalid': validate && validate.msg.resident_id}"
                >
                  <option v-if="residents.length === 0" disabled>沒有住民資料</option>
                  <option :value="null">不綁定住民</option>
                  <option v-for="resident in residents" :value="resident.id" :key="'resident'+ resident.id">
                    {{ resident.name }}
                  </option>
                </select>

                <div class="invalid-feedback" v-if="validate && validate.msg.resident_id">
                  <div v-for="(msg, index) in validate.msg.resident_id" :key="index">
                    {{ msg }}
                  </div>
                </div>
              </div>

              <div class="mb-3" v-show="isSystemManage">
                <label for="editModal_type" class="form-label fw-medium required">
                  {{ $t("__foraDeviceType") }}
                </label>

                <!-- 編輯模式：單選 -->
                <select
                  v-if="isEdit"
                  v-model="modalData.type"
                  class="form-select"
                  id="editModal_type"
                  :class="{
                    'is-invalid': validate && validate.msg.type
                  }"
                >
                  <option key="glucose" value="glucose">
                    {{ $t("__chilineDeviceGlucose") }}
                  </option>
                  <option key="oxygen" value="oxygen">
                    {{ $t("__chilineDeviceOxygen") }}
                  </option>
                  <option key="temperature" value="temperature">
                    {{ $t("__foraDeviceForeheadTemperature") }}
                  </option>
                  <option key="ear_temperature" value="ear_temperature">
                    {{ $t("__foraDeviceEarTemperature") }}
                  </option>
                  <option key="pressure" value="pressure">
                    {{ $t("__chilineDevicePressure") }}
                  </option>
                  <option key="ketone" value="ketone">
                    {{ $t("__chilineDeviceKetone") }}
                  </option>
                  <option key="uric_acid" value="uric_acid">
                    {{ $t("__chilineDeviceUricAcid") }}
                  </option>
                  <option key="cholesterol" value="cholesterol">
                    {{ $t("__chilineDeviceCholesterol") }}
                  </option>
                  <option key="respiratory_rate" value="respiratory_rate">
                    {{ $t("__foraDeviceRespiratoryRate") }}
                  </option>
                  <option key="pain_index" value="pain_index">
                    {{ $t("__foraDevicePainIndex") }}
                  </option>
                  <option key="bowel_movement_count" value="bowel_movement_count">
                    {{ $t("__foraDeviceBowelMovementCount") }}
                  </option>
                </select>

                <!-- 新增模式：多選 -->
                <div v-if="!isEdit">
                  <v-select
                    v-model="modalData.types"
                    :options="deviceTypeOptions"
                    :reduce="option => option.value"
                    label="label"
                    multiple
                    :close-on-select="false"
                    :placeholder="$t('__selectDeviceTypes')"
                    :class="{ 'is-invalid': validate && validate.msg.types }"
                    :components="{ Deselect, OpenIndicator }"
                  >
                  </v-select>

                  <div v-if="modalData.types && modalData.types.length > 0" class="mt-2">
                    <small class="text-muted">
                      {{ $t("__selectedDeviceTypes") }}: {{ modalData.types.length }}
                    </small>
                  </div>
                </div>

                <div class="invalid-feedback" v-if="validate && validate.msg.type">
                  <div v-for="(msg, index) in validate.msg.type" :key="index">
                    {{ msg }}
                  </div>
                </div>
                <div class="invalid-feedback" v-if="validate && validate.msg.types">
                  <div v-for="(msg, index) in validate.msg.types" :key="index">
                    {{ msg }}
                  </div>
                </div>
              </div>

              <!-- 狀態 -->
              <div class="mb-3">
                <label class="form-label fw-medium">{{ $t("__status") }}</label>
                <div>
                  <div class="status-switch">
                    <input
                      type="checkbox"
                      id="editModal_status"
                      v-model="modalData.status"
                    />
                    <label for="editModal_status"></label>
                  </div>
                  <span class="ms-2">{{ modalData.status ? $t('__enabled') : $t('__disabled') }}</span>
                </div>
              </div>

              <!-- 啟用日期 -->
              <div class="mb-3">
                <label for="editModal_started_at" class="form-label fw-medium required">{{
                  $t("__foraStartedAt")
                }}</label>
                <VueCtkDateTimePicker
                  :label="$t('__date')"
                  v-model="modalData.started_at"
                  only-date
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  color="#2CBDC0"
                  button-color="#2CBDC0"
                  id="editModal_started_at"
                  :class="{
                    'is-invalid': validate && validate.msg.started_at
                  }"
                />
                <div class="invalid-feedback" v-if="validate && validate.msg.started_at">
                  <div v-for="(msg, index) in validate.msg.started_at" :key="index">
                    {{ msg }}
                  </div>
                </div>
              </div>

              <!-- 到期日期 -->
              <div class="mb-3">
                <label for="editModal_ended_at" class="form-label fw-medium required">{{
                  $t("__foraEndedAt")
                }}</label>
                <VueCtkDateTimePicker
                  :label="$t('__date')"
                  v-model="modalData.ended_at"
                  only-date
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  color="#2CBDC0"
                  button-color="#2CBDC0"
                  id="editModal_ended_at"
                  :class="{
                    'is-invalid': validate && validate.msg.ended_at
                  }"
                />
                <div class="invalid-feedback" v-if="validate && validate.msg.ended_at">
                  <div v-for="(msg, index) in validate.msg.ended_at" :key="index">
                    {{ msg }}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                class="btn btn-outline-secondary rounded-pill"
                data-bs-dismiss="modal"
              >
                {{ $t("__cancel") }}
              </button>
              <button type="submit" class="btn btn-primary rounded-pill">
                {{ $t("__save") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 批次編輯 Modal (Opt-in) -->
    <div
      class="modal fade cms-style"
      tabindex="-1"
      id="batchEdit"
      ref="batchEditModal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="batchSubmitForm">
            <div class="modal-header">
              <h5 class="modal-title fw-medium">
                {{ $t("__foraBatchEditTitle") }}
              </h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <!-- 修改機構 -->
              <div class="mb-3">
                <div class="form-check mb-2">
                  <input class="form-check-input" type="checkbox" v-model="batchFields.agency_id.enabled" id="batch_agency_check">
                  <label class="form-check-label fw-medium" for="batch_agency_check">{{ $t("__foraModifyAgency") }}</label>
                </div>
                <div v-if="batchFields.agency_id.enabled">
                  <v-select
                    v-if="allAgencys !== null"
                    v-model="batchFields.agency_id.value"
                    :options="allAgencys"
                    label="codename"
                    :reduce="agency => agency.id"
                    :placeholder="$t('__searchAgencyName')"
                    class="style-chooser"
                    :components="{Deselect, OpenIndicator}"
                    :get-option-label="option => `${option.codename} / ${option.name}`"
                  >
                  </v-select>
                  <small class="text-warning">{{ $t("__foraDeviceLevelUpdateHint") }}</small>
                </div>
              </div>

              <!-- 修改群組名稱 -->
              <div class="mb-3">
                <div class="form-check mb-2">
                  <input class="form-check-input" type="checkbox" v-model="batchFields.group_name.enabled" id="batch_group_check">
                  <label class="form-check-label fw-medium" for="batch_group_check">{{ $t("__foraModifyGroupName") }}</label>
                </div>
                <div v-if="batchFields.group_name.enabled">
                  <input
                    v-model="batchFields.group_name.value"
                    type="text"
                    class="form-control"
                    :placeholder="$t('__foraGroupName')"
                  />
                </div>
              </div>

              <!-- 修改住民 -->
              <div class="mb-3">
                <div class="form-check mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="batchFields.resident_id.enabled"
                    id="batch_resident_check"
                    :disabled="!batchResidentAvailable"
                  >
                  <label class="form-check-label fw-medium" for="batch_resident_check">{{ $t("__foraModifyResident") }}</label>
                </div>
                <div v-if="!batchResidentAvailable">
                  <small class="text-danger">{{ $t("__foraResidentSameAgencyRequired") }}</small>
                </div>
                <div v-if="batchFields.resident_id.enabled && batchResidentAvailable">
                  <select v-model="batchFields.resident_id.value" class="form-select">
                    <option v-if="batchResidents.length === 0" disabled>沒有住民資料</option>
                    <option :value="null">不綁定住民</option>
                    <option v-for="resident in batchResidents" :value="resident.id" :key="'batchResident'+ resident.id">
                      {{ resident.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- 修改狀態 -->
              <div class="mb-3">
                <div class="form-check mb-2">
                  <input class="form-check-input" type="checkbox" v-model="batchFields.status.enabled" id="batch_status_check">
                  <label class="form-check-label fw-medium" for="batch_status_check">{{ $t("__foraModifyStatus") }}</label>
                </div>
                <div v-if="batchFields.status.enabled">
                  <div class="status-switch">
                    <input
                      type="checkbox"
                      id="batch_status_toggle"
                      v-model="batchFields.status.value"
                    />
                    <label for="batch_status_toggle"></label>
                  </div>
                  <span class="ms-2">{{ batchFields.status.value ? $t('__enabled') : $t('__disabled') }}</span>
                </div>
              </div>

              <!-- 修改啟用日期 -->
              <div class="mb-3">
                <div class="form-check mb-2">
                  <input class="form-check-input" type="checkbox" v-model="batchFields.started_at.enabled" id="batch_started_check">
                  <label class="form-check-label fw-medium" for="batch_started_check">{{ $t("__foraModifyStartedAt") }}</label>
                </div>
                <div v-if="batchFields.started_at.enabled">
                  <VueCtkDateTimePicker
                    :label="$t('__date')"
                    v-model="batchFields.started_at.value"
                    only-date
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    color="#2CBDC0"
                    button-color="#2CBDC0"
                    id="batch_started_at"
                  />
                </div>
              </div>

              <!-- 修改到期日期 -->
              <div class="mb-3">
                <div class="form-check mb-2">
                  <input class="form-check-input" type="checkbox" v-model="batchFields.ended_at.enabled" id="batch_ended_check">
                  <label class="form-check-label fw-medium" for="batch_ended_check">{{ $t("__foraModifyEndedAt") }}</label>
                </div>
                <div v-if="batchFields.ended_at.enabled">
                  <VueCtkDateTimePicker
                    :label="$t('__date')"
                    v-model="batchFields.ended_at.value"
                    only-date
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    color="#2CBDC0"
                    button-color="#2CBDC0"
                    id="batch_ended_at"
                  />
                </div>
              </div>

              <p class="text-danger">{{ $t('__foraBatchEditWarning') }}</p>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                class="btn btn-outline-secondary rounded-pill"
                data-bs-dismiss="modal"
              >
                {{ $t("__cancel") }}
              </button>
              <button type="submit" class="btn btn-primary rounded-pill" :disabled="!hasBatchFieldEnabled">
                {{ $t("__save") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 狀態切換確認 Modal -->
    <div
      class="modal fade"
      id="changeStatusModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="changeStatusModal"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">{{ $t("__changeStatus") }}</h5>
          </div>
          <div class="modal-body text-center">
            <p class="mb-0">{{ $t("__foraChangeStatusConfirm", {Device: statusChangeDevice}) }}</p>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t("__cancel") }}
            </button>
            <button
              @click="changeStatus"
              type="button"
              class="btn btn-primary rounded-pill"
            >
              {{ $t("__confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 刪除確認 Modal -->
    <div
      class="modal fade"
      id="deleteModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="deleteModal"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">{{ $t("__deleteDevice") }}</h5>
          </div>
          <div class="modal-body text-center">
            <p class="mb-0">{{ $t("__deleteDeviceNote", {Device: modalData.MDeviceId}) }}</p>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t("__cancel") }}
            </button>
            <button
              @click="deleteDevice"
              type="button"
              class="btn btn-primary rounded-pill"
            >
              {{ $t("__confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip, Modal } from 'bootstrap'
import i18n from '@/lang/lang.js'
import { fora } from '@/http/api/fora.js'
import { agency } from '@/http/api/agency.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'Fora',
  components: { VueCtkDateTimePicker, vSelect },
  data () {
    return {
      sortBy: 'id',
      sortDesc: true,
      agencys: null,
      allAgencys: null,
      items: null,
      filterItem: null,
      filter: null,
      filterType: null,
      filterDeviceType: 'all',
      isShowSelected: false,
      selected: [],
      filterOn: ['Idno', 'MDeviceId', 'agency'],
      search: null,
      searchAgency: null,
      searchAgent: null,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      bootstrap_tooltip: null,
      bootstrap_modal: null,
      isEdit: false,
      editModalId: null,
      modalData: {
        agency_id: null,
        resident_id: null,
        MDeviceId: null,
        group_name: null,
        type: null,
        types: [],
        status: true,
        started_at: null,
        ended_at: null,
      },
      validate: null,
      residents: [],
      searchAgencyKeyword: null,
      // 狀態切換
      statusChangeId: null,
      statusChangeDevice: '',
      statusChangeValue: null,
      // 批次編輯 Opt-in fields
      batchFields: {
        agency_id: { enabled: false, value: null },
        group_name: { enabled: false, value: '' },
        resident_id: { enabled: false, value: null },
        status: { enabled: false, value: true },
        started_at: { enabled: false, value: null },
        ended_at: { enabled: false, value: null },
      },
      batchForaIds: [],
      batchResidents: [],
      Deselect: {
        render: createElement => createElement('span', ''),
      },
      OpenIndicator: {
        render: createElement => createElement('span', [
          createElement('img', {
            attrs: {
              src: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e"
            },
            style: {
              width: '16px',
              height: '16px',
            }
          })
        ]),
      },
    }
  },
  computed: {
    ...mapState(['token', 'userInfo']),
    ...mapGetters(['hasPermission', 'isSystemManage']),
    deviceTypeOptions () {
      return [
        { value: 'glucose', label: this.$t('__chilineDeviceGlucose') },
        { value: 'oxygen', label: this.$t('__chilineDeviceOxygen') },
        { value: 'temperature', label: this.$t('__foraDeviceForeheadTemperature') },
        { value: 'ear_temperature', label: this.$t('__foraDeviceEarTemperature') },
        { value: 'pressure', label: this.$t('__chilineDevicePressure') },
        { value: 'ketone', label: this.$t('__chilineDeviceKetone') },
        { value: 'uric_acid', label: this.$t('__chilineDeviceUricAcid') },
        { value: 'cholesterol', label: this.$t('__chilineDeviceCholesterol') },
        { value: 'respiratory_rate', label: this.$t('__foraDeviceRespiratoryRate') },
        { value: 'pain_index', label: this.$t('__foraDevicePainIndex') },
        { value: 'bowel_movement_count', label: this.$t('__foraDeviceBowelMovementCount') },
      ]
    },
    permissions () {
      let permissions = null
      if (this.userInfo) {
        permissions = this.userInfo.permissions
      }
      return permissions
    },
    fields () {
      return [
        {
          key: this.isShowSelected ? 'selected' : null,
          label: i18n.t('__batchEditing'),
          class: 'align-middle text-center',
          sortable: false
        },
        {
          key: 'MDeviceId',
          label: i18n.t('__foraDeviceId'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'group_name',
          label: i18n.t('__foraGroupName'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'type',
          label: i18n.t('__foraDeviceType'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'agency',
          label: i18n.t('__agencyName') + ' / ' + i18n.t('__codeName'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'resident',
          label: i18n.t('__foraResident'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'started_at',
          label: i18n.t('__foraStartedAt'),
          class: 'align-middle text-center',
          sortable: true
        },
        {
          key: 'ended_at',
          label: i18n.t('__foraEndedAt'),
          class: 'align-middle text-center',
          sortable: true
        },
        {
          key: this.isShowSelected ? null : 'status',
          label: i18n.t('__status'),
          class: 'align-middle text-center',
          sortable: false
        },
        {
          key: this.isShowSelected ? null : 'active',
          label: i18n.t('__active'),
          tdClass: 'align-middle',
          class: 'align-middle',
          sortable: false
        }
      ]
    },
    // 批次編輯：是否有任何欄位被勾選
    hasBatchFieldEnabled () {
      return Object.values(this.batchFields).some(f => f.enabled)
    },
    // 批次編輯：選取的設備是否同屬一個機構
    batchResidentAvailable () {
      if (this.selected.length === 0) return false
      const agencyIds = this.selected
        .map(item => item.agency_id)
        .filter(id => id !== null && id !== undefined)
      if (agencyIds.length === 0) return false
      const uniqueIds = [...new Set(agencyIds)]
      return uniqueIds.length === 1
    },
    batchSelectedAgencyId () {
      if (!this.batchResidentAvailable) return null
      const agencyIds = this.selected
        .map(item => item.agency_id)
        .filter(id => id !== null && id !== undefined)
      return agencyIds[0] || null
    }
  },
  watch: {
    items (data) {
      const vm = this
      if (data) {
        vm.filterItem = vm.items
        vm.initBootstrapTooltip()
      }
    },
    filterItem (data) {
      if (data) {
        this.totalRows = data.length
      } else {
        this.totalRows = 0
      }
      this.currentPage = 1
    },
    isShowSelected (data) {
      this.hideTooltip()
      this.initBootstrapTooltip()
      if (!data) {
        this.clearSelected()
      }
    },
    filterType () {
      this.filterItems()
    },
    filterDeviceType () {
      this.filterItems()
    },
    searchAgency () {
      this.filterItems()
    },
    userInfo (data) {
      if (data) {
        this.modalData.manager_id = data.id
      }
    },
    modalData: {
      handler: function () {
        this.validate = null
      },
      deep: true
    },
    'modalData.agency_id' () {
      this.residents = []
      this.getResidents()
    },
    batchSelectedAgencyId (agencyId) {
      if (agencyId) {
        this.getBatchResidents(agencyId)
      } else {
        this.batchResidents = []
      }
    }
  },
  methods: {
    ...mapMutations(['Loading', 'Loaded', 'AlertsInfo', 'Alerted']),
    getAllAgency () {
      const vm = this
      agency.get('', this.token).then((res) => {
        if (res.status <= 201 && res.data.status === 'success') {
          vm.allAgencys = res.data.data
        }
      })
    },
    getResidents () {
      const id = this.modalData.agency_id
      if (!id) return
      agency.getResidents(id, this.token).then((res) => {
        if (res.status <= 201 && res.data.status === 'success') {
          this.residents = res.data.data
        }
      })
    },
    getBatchResidents (agencyId) {
      if (!agencyId) return
      agency.getResidents(agencyId, this.token).then((res) => {
        if (res.status <= 201 && res.data.status === 'success') {
          this.batchResidents = res.data.data
        }
      })
    },
    getForaDevice () {
      const vm = this
      vm.Loading()
      fora
        .get('', vm.token)
        .then((res) => {
          if (res.status <= 201 && res.data.status === 'success') {
            vm.items = res.data.data
          } else {
            vm.AlertsInfo({
              state: 'error',
              title: i18n.t('__error'),
              info: res.data.errMsg.toString()
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.AlertsInfo({
            state: 'error',
            title: i18n.t('__error'),
            info: err
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    // 選取相關
    selectAllRows () {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected () {
      this.$refs.selectableTable.clearSelected()
    },
    onRowSelected (items) {
      this.selected = items
    },
    // 搜尋相關
    searchDevice () {
      this.filter = this.search
    },
    searchAgencyByName () {
      this.filter = this.searchAgencyKeyword
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    clearSearch () {
      this.filter = null
      this.search = null
      this.searchAgencyKeyword = null
    },
    initBootstrapTooltip () {
      this.$nextTick(function () {
        this.bootstrap_tooltip = [].slice
          .call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          .map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl)
          })
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(ele => {
          ele.addEventListener('shown.bs.tooltip', function () {
            setTimeout(() => {
              Tooltip.getInstance(ele).hide()
            }, 600)
          })
        })
      })
    },
    hideTooltip () {
      if (this.bootstrap_tooltip && this.bootstrap_tooltip.length) {
        this.bootstrap_tooltip.forEach((tooltip) => {
          tooltip.hide()
        })
      }
    },
    // 單筆編輯 Modal
    showModal (id) {
      const vm = this
      vm.resetModalData()
      vm.editModalId = id
      if (id) {
        vm.isEdit = true
        vm.items.forEach((item) => {
          if (item.id === id) {
            vm.modalData.agency_id = item.agency_id
            vm.modalData.resident_id = item.resident_id
            vm.modalData.MDeviceId = item.MDeviceId
            vm.modalData.group_name = item.group_name
            vm.modalData.type = item.type
            vm.modalData.status = !!item.status
            vm.modalData.started_at = item.started_at ? new Date(item.started_at).format('yyyy-MM-dd') : null
            vm.modalData.ended_at = item.ended_at ? new Date(item.ended_at).format('yyyy-MM-dd') : null
          }
        })
      } else {
        vm.isEdit = false
      }
      vm.bootstrap_modal = new Modal(vm.$refs.editModal)
      vm.$nextTick(function () {
        vm.bootstrap_modal.show()
      })
    },
    resetModalData () {
      this.modalData.agency_id = null
      this.modalData.resident_id = null
      this.modalData.MDeviceId = null
      this.modalData.group_name = null
      this.modalData.type = null
      this.modalData.types = []
      this.modalData.status = true
      this.modalData.started_at = null
      this.modalData.ended_at = null
      this.editModalId = null
    },
    submitForm () {
      const vm = this

      // 編輯模式
      if (vm.isEdit && vm.editModalId) {
        vm.Loading()
        fora
          .update(
            vm.editModalId,
            {
              agency_id: vm.modalData.agency_id,
              resident_id: vm.modalData.resident_id,
              MDeviceId: vm.modalData.MDeviceId,
              group_name: vm.modalData.group_name,
              type: vm.modalData.type,
              status: vm.modalData.status ? 1 : 0,
              started_at: vm.modalData.started_at,
              ended_at: vm.modalData.ended_at,
            },
            vm.token
          )
          .then((res) => {
            if (res.status <= 201 && res.data.status === 'success') {
              vm.getForaDevice()
              vm.AlertsInfo({
                state: 'success',
                title: i18n.t('__success'),
                info: i18n.t('__editSuccess')
              })
              vm.bootstrap_modal.hide()
              vm.resetModalData()
            } else {
              vm.AlertsInfo({
                state: 'error',
                title: i18n.t('__error'),
                info: res.data.errMsg.toString()
              })
              vm.validate = res.data.validate
            }
            vm.Loaded()
            vm.Alerted()
          })
      } else {
        // 新增模式
        vm.createMultipleDevices()
      }
    },
    async createMultipleDevices () {
      const vm = this

      try {
        vm.Loading()

        const payload = {
          MDeviceId: vm.modalData.MDeviceId,
          group_name: vm.modalData.group_name,
          agency_id: vm.modalData.agency_id,
          resident_id: vm.modalData.resident_id,
          types: vm.modalData.types,
          status: vm.modalData.status ? 1 : 0,
          started_at: vm.modalData.started_at,
          ended_at: vm.modalData.ended_at,
        }

        const response = await fora.batchCreate(payload, vm.token)

        vm.Loaded()

        if (response.data.status === 'success') {
          vm.getForaDevice()
          vm.AlertsInfo({
            state: 'success',
            title: i18n.t('__success'),
            info: response.data.message
          })
          vm.bootstrap_modal.hide()
          vm.resetModalData()
        } else if (response.data.status === 'partial_success') {
          const results = response.data.results
          vm.getForaDevice()

          const successCount = results.success ? results.success.length : 0
          const failedCount = results.failed ? results.failed.length : 0

          let errorMessage = i18n.t('__partialSuccess') + '<br>'
          errorMessage += i18n.t('__successCount') + ': ' + successCount + '<br>'
          errorMessage += i18n.t('__failedCount') + ': ' + failedCount

          if (results.failed && results.failed.length > 0) {
            errorMessage += '<hr>' + vm.formatBatchErrors(results.failed)
          }

          vm.AlertsInfo({
            state: 'warning',
            title: i18n.t('__partialSuccess'),
            info: errorMessage
          })
          vm.bootstrap_modal.hide()
          vm.resetModalData()
        }
        vm.Alerted()
      } catch (error) {
        vm.Loaded()

        let errorMessage = i18n.t('__createDeviceFailed')
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message
        }

        vm.AlertsInfo({
          state: 'error',
          title: i18n.t('__error'),
          info: errorMessage
        })
        vm.Alerted()
      }
    },
    formatBatchErrors (failures) {
      if (!failures || failures.length === 0) return ''

      const messages = failures.map(f => {
        const deviceId = f && f.device_id ? f.device_id : 'unknown'
        const type = f && f.type ? f.type : 'unknown'
        const error = f && f.error ? f.error : 'unknown error'

        return '<div class="text-start"><strong>' + deviceId + '</strong> (' + type + '): ' + error + '</div>'
      }).join('')

      return '<div class="mt-2">' + messages + '</div>'
    },
    // 狀態切換
    changeStatusAlert (item) {
      const vm = this
      vm.statusChangeId = item.id
      vm.statusChangeDevice = item.MDeviceId
      vm.statusChangeValue = item.status ? 0 : 1
      vm.bootstrap_modal = new Modal(vm.$refs.changeStatusModal)
      vm.bootstrap_modal.show()
      vm.$refs.changeStatusModal.addEventListener('hidden.bs.modal', () => {
        vm.getForaDevice()
      }, { once: true })
    },
    changeStatus () {
      const vm = this
      vm.Loading()
      fora
        .changeStatus(
          vm.statusChangeId,
          { status: vm.statusChangeValue },
          vm.token
        )
        .then((res) => {
          if (res.status <= 201 && res.data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: i18n.t('__success'),
              info: i18n.t('__changeStatus') + i18n.t('__success')
            })
          } else {
            vm.AlertsInfo({
              state: 'error',
              title: i18n.t('__error'),
              info: res.data.errMsg.toString()
            })
          }
          vm.Loaded()
          vm.Alerted()
          vm.bootstrap_modal.hide()
        })
    },
    // 批次編輯 Modal
    showBatchEditModal () {
      const vm = this
      vm.resetBatchFields()
      vm.batchForaIds = vm.selected.map(item => item.id)

      vm.bootstrap_modal = new Modal(vm.$refs.batchEditModal)
      vm.$nextTick(function () {
        vm.bootstrap_modal.show()
      })
    },
    resetBatchFields () {
      this.batchFields = {
        agency_id: { enabled: false, value: null },
        group_name: { enabled: false, value: '' },
        resident_id: { enabled: false, value: null },
        status: { enabled: false, value: true },
        started_at: { enabled: false, value: null },
        ended_at: { enabled: false, value: null },
      }
      this.batchForaIds = []
    },
    batchSubmitForm () {
      const vm = this

      // 組裝只有勾選的欄位
      const fields = {}
      Object.keys(vm.batchFields).forEach(key => {
        if (vm.batchFields[key].enabled) {
          let value = vm.batchFields[key].value
          if (key === 'status') {
            value = value ? 1 : 0
          }
          fields[key] = value
        }
      })

      if (Object.keys(fields).length === 0) return

      vm.Loading()
      fora
        .batchUpdate(
          {
            foraIds: vm.batchForaIds,
            fields: fields
          },
          vm.token
        )
        .then((res) => {
          if (res.status <= 201 && res.data.status === 'success') {
            vm.getForaDevice()
            vm.AlertsInfo({
              state: 'success',
              title: i18n.t('__success'),
              info: i18n.t('__editSuccess')
            })
            vm.bootstrap_modal.hide()
          } else {
            vm.AlertsInfo({
              state: 'error',
              title: i18n.t('__error'),
              info: res.data.errMsg.toString()
            })
          }
          vm.Loaded()
          vm.Alerted()
        })
    },
    // 刪除
    deleteDeviceAlert (id) {
      const vm = this
      vm.editModalId = id
      vm.items.forEach((item) => {
        if (item.id === id) {
          vm.modalData.MDeviceId = item.MDeviceId
        }
      })
      vm.bootstrap_modal = new Modal(vm.$refs.deleteModal)
      vm.bootstrap_modal.show()
      vm.$refs.deleteModal.addEventListener('hidden.bs.modal', () => {
        vm.getForaDevice()
      }, { once: true })
    },
    deleteDevice () {
      const vm = this
      fora
        .delete(
          vm.editModalId,
          vm.token
        )
        .then((res) => {
          if (res.status <= 201 && res.data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: i18n.t('__success'),
              info: i18n.t('__deleteDevice') + i18n.t('__success')
            })
            vm.getForaDevice()
            vm.resetModalData()
          } else {
            vm.AlertsInfo({
              state: 'error',
              title: i18n.t('__error'),
              info: res.data.errMsg.toString()
            })
          }
          vm.Alerted()
          vm.Loaded()
          vm.bootstrap_modal.hide()
        })
    },
    filterItems () {
      if (!this.items) return
      this.filterItem = this.items.filter(item => {
        let matchesAgency = true
        if (this.searchAgency !== null) {
          matchesAgency = item.agency_id === this.searchAgency
        }

        if (this.searchAgencyKeyword) {
          matchesAgency = item.agency && (
            (item.agency.codename && item.agency.codename.toLowerCase().includes(this.searchAgencyKeyword.toLowerCase())) ||
            (item.agency.name && item.agency.name.toLowerCase().includes(this.searchAgencyKeyword.toLowerCase()))
          )
        }

        let matchesType = true
        switch (this.filterType) {
          case 0:
            matchesType = !item.agency_id
            break
          case 1:
            matchesType = !!item.agency_id
            break
        }

        let matchesDeviceType = true
        if (this.filterDeviceType !== 'all') {
          matchesDeviceType = item.type === this.filterDeviceType
        }

        return matchesAgency && matchesType && matchesDeviceType
      })
    }
  },
  created () {
    this.getForaDevice()
    this.getAllAgency()
  },
  mounted () {}
}
</script>

<style lang="scss">
  .style-chooser {
    border: 1px solid #ced4da;
    border-radius: 0.375rem;
    padding: 0.1rem 0.35rem 0.1rem 0.15rem;
    --vs-controls-color: #4F5258;
    --vs-controls-size: 0.8;
    --vs-controls--deselect-text-shadow: 0 1px 0 #fff;

    .vs__search::placeholder,
    .vs__dropdown-toggle,
    .vs__dropdown-menu {
      background: #ffffff;
      border: none;
      color: #000;
    }
  }

  .status-switch {
    display: inline-block;
    position: relative;

    input[type="checkbox"] {
      display: none;

      &:checked + label {
        background-color: #2CBDC0;

        &::after {
          left: 22px;
        }
      }
    }

    label {
      display: block;
      width: 44px;
      height: 24px;
      background-color: #ccc;
      border-radius: 12px;
      cursor: pointer;
      position: relative;
      transition: background-color 0.3s;

      &::after {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 20px;
        height: 20px;
        background-color: white;
        border-radius: 50%;
        transition: left 0.3s;
      }
    }
  }
</style>
